"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _useIsomorphicLayoutEffect = _interopRequireDefault(require("./useIsomorphicLayoutEffect"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_23cthpb3b0() {
  var path = "/__w/code/code/js/packages/bricks/src/hooks/useDimensions.ts";
  var hash = "a4c4eef9c8cde967f873d4dd4906fd430be30282";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/hooks/useDimensions.ts",
    statementMap: {
      "0": {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 38,
          column: 3
        }
      },
      "1": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 37,
          column: 6
        }
      },
      "2": {
        start: {
          line: 39,
          column: 15
        },
        end: {
          line: 39,
          column: 43
        }
      },
      "3": {
        start: {
          line: 41,
          column: 2
        },
        end: {
          line: 51,
          column: 4
        }
      },
      "4": {
        start: {
          line: 56,
          column: 38
        },
        end: {
          line: 56,
          column: 52
        }
      },
      "5": {
        start: {
          line: 57,
          column: 26
        },
        end: {
          line: 57,
          column: 40
        }
      },
      "6": {
        start: {
          line: 59,
          column: 14
        },
        end: {
          line: 61,
          column: 8
        }
      },
      "7": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 60,
          column: 18
        }
      },
      "8": {
        start: {
          line: 63,
          column: 2
        },
        end: {
          line: 81,
          column: 13
        }
      },
      "9": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 78,
          column: 5
        }
      },
      "10": {
        start: {
          line: 65,
          column: 22
        },
        end: {
          line: 66,
          column: 83
        }
      },
      "11": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 66,
          column: 83
        }
      },
      "12": {
        start: {
          line: 66,
          column: 43
        },
        end: {
          line: 66,
          column: 82
        }
      },
      "13": {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 67,
          column: 16
        }
      },
      "14": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 77,
          column: 7
        }
      },
      "15": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 70,
          column: 51
        }
      },
      "16": {
        start: {
          line: 71,
          column: 8
        },
        end: {
          line: 71,
          column: 51
        }
      },
      "17": {
        start: {
          line: 73,
          column: 8
        },
        end: {
          line: 76,
          column: 10
        }
      },
      "18": {
        start: {
          line: 74,
          column: 10
        },
        end: {
          line: 74,
          column: 56
        }
      },
      "19": {
        start: {
          line: 75,
          column: 10
        },
        end: {
          line: 75,
          column: 56
        }
      },
      "20": {
        start: {
          line: 83,
          column: 2
        },
        end: {
          line: 83,
          column: 35
        }
      }
    },
    fnMap: {
      "0": {
        name: "getDimensionObject",
        decl: {
          start: {
            line: 26,
            column: 9
          },
          end: {
            line: 26,
            column: 27
          }
        },
        loc: {
          start: {
            line: 26,
            column: 72
          },
          end: {
            line: 52,
            column: 1
          }
        },
        line: 26
      },
      "1": {
        name: "useDimensions",
        decl: {
          start: {
            line: 55,
            column: 9
          },
          end: {
            line: 55,
            column: 22
          }
        },
        loc: {
          start: {
            line: 55,
            column: 92
          },
          end: {
            line: 84,
            column: 1
          }
        },
        line: 55
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 59,
            column: 26
          },
          end: {
            line: 59,
            column: 27
          }
        },
        loc: {
          start: {
            line: 59,
            column: 36
          },
          end: {
            line: 61,
            column: 3
          }
        },
        line: 59
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 63,
            column: 28
          },
          end: {
            line: 63,
            column: 29
          }
        },
        loc: {
          start: {
            line: 63,
            column: 34
          },
          end: {
            line: 81,
            column: 3
          }
        },
        line: 63
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 65,
            column: 22
          },
          end: {
            line: 65,
            column: 23
          }
        },
        loc: {
          start: {
            line: 66,
            column: 8
          },
          end: {
            line: 66,
            column: 83
          }
        },
        line: 66
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 66,
            column: 37
          },
          end: {
            line: 66,
            column: 38
          }
        },
        loc: {
          start: {
            line: 66,
            column: 43
          },
          end: {
            line: 66,
            column: 82
          }
        },
        line: 66
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 73,
            column: 15
          },
          end: {
            line: 73,
            column: 16
          }
        },
        loc: {
          start: {
            line: 73,
            column: 21
          },
          end: {
            line: 76,
            column: 9
          }
        },
        line: 73
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 27
      },
      "1": {
        loc: {
          start: {
            line: 44,
            column: 9
          },
          end: {
            line: 44,
            column: 33
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 44,
            column: 23
          },
          end: {
            line: 44,
            column: 29
          }
        }, {
          start: {
            line: 44,
            column: 32
          },
          end: {
            line: 44,
            column: 33
          }
        }],
        line: 44
      },
      "2": {
        loc: {
          start: {
            line: 45,
            column: 10
          },
          end: {
            line: 45,
            column: 34
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 45,
            column: 24
          },
          end: {
            line: 45,
            column: 30
          }
        }, {
          start: {
            line: 45,
            column: 33
          },
          end: {
            line: 45,
            column: 34
          }
        }],
        line: 45
      },
      "3": {
        loc: {
          start: {
            line: 46,
            column: 7
          },
          end: {
            line: 46,
            column: 31
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 46,
            column: 21
          },
          end: {
            line: 46,
            column: 27
          }
        }, {
          start: {
            line: 46,
            column: 30
          },
          end: {
            line: 46,
            column: 31
          }
        }],
        line: 46
      },
      "4": {
        loc: {
          start: {
            line: 47,
            column: 7
          },
          end: {
            line: 47,
            column: 31
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 47,
            column: 21
          },
          end: {
            line: 47,
            column: 27
          }
        }, {
          start: {
            line: 47,
            column: 30
          },
          end: {
            line: 47,
            column: 31
          }
        }],
        line: 47
      },
      "5": {
        loc: {
          start: {
            line: 55,
            column: 23
          },
          end: {
            line: 55,
            column: 71
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 55,
            column: 69
          },
          end: {
            line: 55,
            column: 71
          }
        }],
        line: 55
      },
      "6": {
        loc: {
          start: {
            line: 55,
            column: 25
          },
          end: {
            line: 55,
            column: 43
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 55,
            column: 39
          },
          end: {
            line: 55,
            column: 43
          }
        }],
        line: 55
      },
      "7": {
        loc: {
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 64
      },
      "8": {
        loc: {
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 77,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 77,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 69
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0],
      "6": [0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a4c4eef9c8cde967f873d4dd4906fd430be30282"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_23cthpb3b0 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_23cthpb3b0();
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function getDimensionObject(node) {
  cov_23cthpb3b0().f[0]++;
  cov_23cthpb3b0().s[0]++;
  if (!node) {
    cov_23cthpb3b0().b[0][0]++;
    cov_23cthpb3b0().s[1]++;
    return {
      width: 0,
      height: 0,
      top: 0,
      left: 0,
      x: 0,
      y: 0,
      right: 0,
      bottom: 0
    };
  } else {
    cov_23cthpb3b0().b[0][1]++;
  }
  var rect = (cov_23cthpb3b0().s[2]++, node.getBoundingClientRect());
  cov_23cthpb3b0().s[3]++;
  return {
    width: rect.width,
    height: rect.height,
    top: 'x' in rect ? (cov_23cthpb3b0().b[1][0]++, rect.x) : (cov_23cthpb3b0().b[1][1]++, 0),
    left: 'y' in rect ? (cov_23cthpb3b0().b[2][0]++, rect.y) : (cov_23cthpb3b0().b[2][1]++, 0),
    x: 'x' in rect ? (cov_23cthpb3b0().b[3][0]++, rect.x) : (cov_23cthpb3b0().b[3][1]++, 0),
    y: 'y' in rect ? (cov_23cthpb3b0().b[4][0]++, rect.y) : (cov_23cthpb3b0().b[4][1]++, 0),
    right: rect.right,
    bottom: rect.bottom
  };
}

// useDimensions is originally from npm package: https://github.com/Swizec/useDimensions
function useDimensions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_23cthpb3b0().b[5][0]++, {}),
    _ref$liveMeasure = _ref.liveMeasure,
    liveMeasure = _ref$liveMeasure === void 0 ? (cov_23cthpb3b0().b[6][0]++, true) : _ref$liveMeasure;
  cov_23cthpb3b0().f[1]++;
  var _ref2 = (cov_23cthpb3b0().s[4]++, (0, _react.useState)(null)),
    _ref3 = _slicedToArray(_ref2, 2),
    dimensions = _ref3[0],
    setDimensions = _ref3[1];
  var _ref4 = (cov_23cthpb3b0().s[5]++, (0, _react.useState)(null)),
    _ref5 = _slicedToArray(_ref4, 2),
    node = _ref5[0],
    setNode = _ref5[1];
  var ref = (cov_23cthpb3b0().s[6]++, (0, _react.useCallback)(function (node) {
    cov_23cthpb3b0().f[2]++;
    cov_23cthpb3b0().s[7]++;
    setNode(node);
  }, []));
  cov_23cthpb3b0().s[8]++;
  (0, _useIsomorphicLayoutEffect["default"])(function () {
    cov_23cthpb3b0().f[3]++;
    cov_23cthpb3b0().s[9]++;
    if (node) {
      cov_23cthpb3b0().b[7][0]++;
      cov_23cthpb3b0().s[10]++;
      var measure = function measure() {
        cov_23cthpb3b0().f[4]++;
        cov_23cthpb3b0().s[11]++;
        return window.requestAnimationFrame(function () {
          cov_23cthpb3b0().f[5]++;
          cov_23cthpb3b0().s[12]++;
          return setDimensions(getDimensionObject(node));
        });
      };
      cov_23cthpb3b0().s[13]++;
      measure();
      cov_23cthpb3b0().s[14]++;
      if (liveMeasure) {
        cov_23cthpb3b0().b[8][0]++;
        cov_23cthpb3b0().s[15]++;
        window.addEventListener('resize', measure);
        cov_23cthpb3b0().s[16]++;
        window.addEventListener('scroll', measure);
        cov_23cthpb3b0().s[17]++;
        return function () {
          cov_23cthpb3b0().f[6]++;
          cov_23cthpb3b0().s[18]++;
          window.removeEventListener('resize', measure);
          cov_23cthpb3b0().s[19]++;
          window.removeEventListener('scroll', measure);
        };
      } else {
        cov_23cthpb3b0().b[8][1]++;
      }
    } else {
      cov_23cthpb3b0().b[7][1]++;
    }
    // TODO (4-13-2020) investigate warning
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [node]);
  cov_23cthpb3b0().s[20]++;
  return {
    ref: ref,
    dimensions: dimensions,
    node: node
  };
}
var _default = exports["default"] = useDimensions;